const SHIP_CODE_REGEX = '.{2}';
const ID_REGEX = '.{1,100}';
const DATE_REGEX = '20[0-9]{2}([0-9]{2}){2}';
const FILE_REGEX = '.+.(pdf|docx)';

export const ENDPOINTS_CONFIG = [
  {
    method: 'GET',
    serviceName: 'Countries Service',
    operation: 'getCountryList',
    version: 'v2',
    path: '/generics/countries',
  },
  {
    method: 'GET',
    serviceName: 'employee-master-list',
    operation: 'getPortInfo',
    version: 'v1',
    path: '/employee/master/ports',
  },
  {
    method: 'GET',
    serviceName: 'employee-master-list',
    operation: 'getShipCodeMaster',
    version: 'v1',
    path: '/employee/master/ships',
  },
  {
    method: 'GET',
    serviceName: 'employee-assignments',
    operation: 'getCrewAssignments',
    version: 'v1',
    path: '/employee/assignments',
  },
  {
    method: 'GET',
    serviceName: 'employee-master-list',
    operation: 'getCrewEffectsMaster',
    version: 'v2',
    path: '/employee/crewEffects/master',
  },
  {
    method: 'GET',
    serviceName: 'employee-crew-effects',
    operation: 'getCrewEffects_v2',
    version: 'v2',
    path: '/employee/crewEffects/customInfo',
  },
  {
    method: 'GET',
    serviceName: 'employee-profiles',
    operation: 'getCrewMemberProfile-V1',
    version: 'v1',
    path: '/employee/profiles',
  },
  {
    method: 'GET',
    serviceName: 'employee-assignments',
    operation: 'getEnhancedShipSignons',
    version: 'v1',
    path: '/employee/assignments/enhancedShipSignons/ships',
  },
  {
    method: 'GET',
    serviceName: 'employee-assignments',
    operation: 'getShipSignoffs',
    version: 'v1',
    path: '/employee/assignments/shipSignoffs/ship',
  },
  {
    method: 'GET',
    serviceName: 'employee-policy-acknowledgements',
    operation: 'getSignOnPoliciesAcknowledgement',
    version: 'v1',
    path: '/employee/policies/acknowledgement/signonDates',
  },
  {
    method: 'GET',
    serviceName: 'employee-assignments',
    operation: 'getAssignments',
    version: 'v1',
    path: '/employee/assignments/shipSignons/ships',
  },
  {
    method: 'POST',
    serviceName: 'employee-profiles',
    operation: 'updateEmployeeProfile',
    version: 'v1',
    path: '/employee/profiles',
  },
  {
    method: 'POST',
    serviceName: 'employee-policy-acknowledgements',
    operation: 'updateSignonPoliciesAcknowledgement',
    version: 'v1',
    path: '/employee/policies/acknowledgement',
  },
  {
    method: 'GET',
    serviceName: 'Agreement Info',
    operation: 'getAgreementInfoV3',
    version: 'v3',
    path: '/agreement/employee?type=',
  },
  {
    method: 'GET',
    serviceName: 'employee-master-list',
    operation: 'getPhoneTypeMaster',
    version: 'v1',
    path: '/employee/master/phoneTypes',
  },
  {
    method: 'GET',
    serviceName: 'employee-service-agreements',
    operation: 'getSOEAFromEFS',
    version: 'v1',
    path: `/employee/serviceAgreements`,
    pathRegex: `/employee/serviceAgreements/${FILE_REGEX}`,
  },
  {
    method: 'GET',
    serviceName: 'employee-reports',
    operation: 'getReportCSV',
    version: 'v1',
    path: '/employee/reports',
  },
  {
    method: 'GET',
    serviceName: 'employee-health-check',
    operation: 'getHealthCheckSurvey',
    version: 'v1',
    path: '/employee/healthCheck/survey/ships',
  },
  {
    method: 'POST',
    serviceName: 'employee-health-check',
    operation: 'updateHealthCheckSurvey',
    version: 'v1',
    path: '/employee/healthCheck/survey',
  },
  {
    method: 'GET',
    serviceName: 'employee-crew-workflow',
    operation: 'getWorkflowState',
    version: 'v2',
    path: `/employee/checkin/workflow/ships`,
    pathRegex: `/employee/checkin/workflow/ships/${SHIP_CODE_REGEX}/signonDates/${DATE_REGEX}`,
  },
  {
    method: 'PUT',
    serviceName: 'employee-crew-checkin-workflow',
    operation: 'updateWorkflowState',
    version: 'v2',
    path: '/employee/checkin/workflow',
  },
  {
    method: 'GET',
    serviceName: 'employee-physique',
    operation: 'getCrewPhysique',
    version: 'v1',
    path: '/employee/crewPhysique',
  },
  {
    method: 'POST',
    serviceName: 'employee-physique',
    operation: 'updateCrewPhysique',
    version: 'v1',
    path: '/employee/crewPhysique',
  },
  {
    method: 'POST',
    serviceName: 'Misc',
    operation: 'rateCheckinExperience',
    version: 'v1',
    path: '/employee/checkin/experience/rating',
  },
  {
    method: 'GET',
    serviceName: 'employee-content',
    operation: 'getContentFAQS',
    version: 'v1',
    path: '/employee/content/faqs',
  },
  {
    method: 'GET',
    serviceName: 'AEM-content',
    operation: 'getContentDiseases',
    version: '',
    path: '/images/content/excalibur/en/stringStore/PRECHECK_MEDICAL_INFO.mobile.json',
  },
  {
    method: 'POST',
    serviceName: 'employee-docusign',
    operation: 'retrievingRecipientViewUrlForCrewmember',
    version: 'v1',
    path: '/employee/docusign/views/recipient',
  },
  {
    method: 'POST',
    serviceName: 'employee-docusign',
    operation: 'retrievingConsoleViewUrlForHR',
    version: 'v1',
    path: '/employee/docusign/views/console',
  },
  {
    method: 'GET',
    serviceName: 'employee-health-check',
    operation: 'getHealthCheckSurveyContent',
    version: 'v1',
    path: '/employee/healthCheck/survey/content',
  },
  {
    method: 'POST',
    serviceName: 'employee-docusign',
    operation: 'deleteMultipleWatermarks',
    version: 'v1',
    path: '/employee/docusign/envelopes/recipients/watermarkRecipients',
  },
  {
    method: 'PUT',
    serviceName: 'employee-assignments',
    operation: 'activateAssignment',
    version: 'v1',
    path: `/employee/assignments/ships`,
    pathRegex: `/employee/assignments/ships/${SHIP_CODE_REGEX}/signonDates/${DATE_REGEX}/activate`,
  },
  {
    method: 'GET',
    serviceName: 'employee-sharepoint-upload',
    operation: 'getSOEAFromSharepoint',
    version: 'v1',
    path: '/employee/sharepoint/file?crewMemberId=',
  },
  {
    method: 'GET',
    serviceName: 'employee-photo',
    operation: 'getCrewPhoto',
    version: 'v1',
    path: `/employee/photo`,
    pathRegex: `/employee/photo/${ID_REGEX}`,
  },
  {
    method: 'PUT',
    serviceName: 'employee-photo',
    operation: 'updateCrewPhoto',
    version: 'v1',
    path: `/employee/photo`,
    pathRegex: `/employee/photo/${ID_REGEX}`,
  },
  {
    method: 'PUT',
    serviceName: 'employee-photo',
    operation: 'syncCrewPhoto',
    version: 'v1',
    path: `/employee/photo/sync`,
    pathRegex: `/employee/photo/sync/${ID_REGEX}`,
  },
  {
    method: 'GET',
    serviceName: 'employee-health-check',
    operation: 'getHealthCheckVaccinesInfo',
    version: 'v1',
    path: 'employee/healthCheck/vaccine/doses',
  },
  {
    method: 'POST',
    serviceName: 'integration',
    operation: 'addVaccineCard',
    version: 'v1',
    path: 'seacare/crew-members/document-submissions',
  },
  {
    method: 'POST',
    serviceName: 'employee-crew-effects',
    operation: 'updateCrewEffects',
    version: 'v2',
    path: 'employee/crewEffects',
  },
  {
    method: 'GET',
    serviceName: 'employee-crew-workflow',
    operation: 'getCheckoutWorkflowState',
    version: 'v2',
    path: `/employee/checkout/workflow/ships`,
    pathRegex: `/employee/checkout/workflow/ships/${SHIP_CODE_REGEX}/signoffDates/${DATE_REGEX}`,
  },
  {
    method: 'GET',
    serviceName: 'employee-policy-acknowledgements',
    operation: 'getSignOffPoliciesAcknowledgement',
    version: 'v1',
    path: `/employee/policies/acknowledgement/signoffDates`,
    pathRegex: `/employee/policies/acknowledgement/signoffDates/${DATE_REGEX}/ships/${SHIP_CODE_REGEX}`,
  },
  {
    method: 'PUT',
    serviceName: 'employee-policy-acknowledgements',
    operation: 'updateSignoffPoliciesAcknowledgement',
    version: 'v1',
    path: `/employee/policies/acknowledgement/debark`,
  },
  {
    method: 'POST',
    serviceName: 'employee-docusign',
    operation: 'postRetrievingConsoleViewUrlForCrewmber',
    version: 'v1',
    path: `/employee/docusign/views/console`,
    pathRegex: `/employee/docusign/views/console`,
  },
];
